import React, { useEffect } from "react";
import { Heading } from "../../../subComponents/Heading";
import { Img } from "../../../subComponents/img";
import { Text } from "../../../subComponents/text";
import AOS from "aos";
import "aos/dist/aos.css";

const ChairManMessageSection = ({text,name,post,imageUrl}) => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <section className="message_section">

        <div
          className="inner_message_container"
          style={{ overflowX: "hidden" }}
        >
          {/* message container left start from here */}
          <div className="message_container_left" data-aos="fade-right">
            <div className="chairmain_image">
              <Img
                src={imageUrl}
                alt={"chairman image"}
              />
            </div>
          </div>
          {/* message container left close from here */}

          {/* message container right start from here*/}
          <div className="message_container_right" data-aos="fade-left">
          <Heading
          orangeheading={name}
          // title={"Message"}
          style={{ textAlign: "", paddingBottom: "0rem", paddingLeft:"0.2rem" }}
          data-aos="zoom-in"
        />
                  <Heading
          title={post}
          style={{ textAlign: "", paddingBottom: "1rem", paddingLeft:"0.2rem" }}
          data-aos="zoom-in"
        />
        
            <div className="innermessage_container">
              <Text
                text={text}
                style={{ fontSize: "1rem" }}
              />
            </div>
          </div>
          {/* message container right close from here */}
        </div>
      </section>
    </>
  );
};
export { ChairManMessageSection };
